import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, Card, getTestId, isValidObject, Typography } from '@airtel/air-design-system';
import { useState } from 'react';
import { View } from 'react-native';
import { withBoundaries } from '../../hoc';
import { CarouselWidget } from '../../components/carousel-widget';
import { CounterWidget } from '../../components/counter-widget';
import { getInfoSummary2WidgetStyles } from './InfoSummary2WidgetStyles';
var InfoSummary2WidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoSummary2Widget' : _props$testID,
    carouselProps = props.carouselProps,
    productDetails = props.productDetails,
    onIncrementButtonPressMetaData = props.onIncrementButtonPressMetaData,
    onDecrementButtonPressMetaData = props.onDecrementButtonPressMetaData,
    _onUserAction = props.onUserAction;
  var _ref = productDetails || {},
    knowMoreButtonProps = _ref.knowMoreButtonProps,
    addButtonProps = _ref.addButtonProps,
    name = _ref.name,
    tc = _ref.tc,
    description = _ref.description,
    price = _ref.price,
    maxProductValue = _ref.maxProductValue,
    onLeftCtaPress = _ref.onLeftCtaPress,
    onRightCtaPress = _ref.onRightCtaPress;
  var infoSummary2WidgetStyles = getInfoSummary2WidgetStyles();
  var _useState = useState(false),
    showCounterWidget = _useState[0],
    setShowCounterWidget = _useState[1];
  return _jsxs(Card, Object.assign({
    style: infoSummary2WidgetStyles.cardStyle,
    noPadding: true
  }, {
    children: [carouselProps && _jsx(CarouselWidget, Object.assign({}, carouselProps, {
      onUserAction: _onUserAction
    })), _jsxs(View, Object.assign({
      style: infoSummary2WidgetStyles === null || infoSummary2WidgetStyles === void 0 ? void 0 : infoSummary2WidgetStyles.productPadding
    }, {
      children: [_jsx(Typography, Object.assign({
        type: 'body-para-lg-bold',
        color: BLACK_900,
        text: name
      }, getTestId(testID, 'productName'))), _jsx(Typography, Object.assign({
        type: 'body-para-sm',
        color: BLACK_700,
        text: description
      }, getTestId(testID, 'productDesc'))), _jsxs(View, Object.assign({
        style: infoSummary2WidgetStyles.paddingTopBottom
      }, {
        children: [_jsx(Typography, Object.assign({
          type: 'body-para-sm-bold',
          color: BLACK_900,
          text: price
        }, getTestId(testID, 'productPrice'))), _jsx(Typography, Object.assign({
          type: 'body-para-xs',
          color: BLACK_700,
          text: tc
        }, getTestId(testID, 'productTc')))]
      })), _jsxs(View, Object.assign({
        style: infoSummary2WidgetStyles.buttonContainer
      }, {
        children: [_jsx(Button, Object.assign({
          buttonType: "tertiary"
        }, knowMoreButtonProps, {
          onPress: () => {
            isValidObject(onLeftCtaPress) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onLeftCtaPress), Object.assign({}, props)));
          }
        }, getTestId(testID, 'knowMoreCta'))), showCounterWidget ? _jsx(CounterWidget, Object.assign({
          minValue: "0",
          maxValue: maxProductValue,
          onDecrementButtonPressMetaData: onDecrementButtonPressMetaData,
          onIncrementButtonPressMetaData: onIncrementButtonPressMetaData,
          onUserAction: function onUserAction() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            _onUserAction(...args);
            var currentValue = args[1].currentValue;
            if (currentValue == 0) {
              setShowCounterWidget(!showCounterWidget);
            }
          }
        }, getTestId(testID, 'CounterWidgetContainer'))) : _jsx(Button, Object.assign({
          buttonType: "secondary"
        }, addButtonProps, {
          style: infoSummary2WidgetStyles === null || infoSummary2WidgetStyles === void 0 ? void 0 : infoSummary2WidgetStyles.addBtnStyle,
          onPress: () => {
            setShowCounterWidget(!showCounterWidget);
            isValidObject(onRightCtaPress) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onRightCtaPress), Object.assign({}, props)));
          }
        }, getTestId(testID, 'addCta')))]
      }))]
    }))]
  }));
};
InfoSummary2WidgetComponent.genericRendererKey = 'AirInfoSummary2Widget';
export var InfoSummary2Widget = withBoundaries(InfoSummary2WidgetComponent);